import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../core/shared/shared.module";
import { WorklogDetailsComponent } from "./worklog-details.component";
import { LoginRest } from "../../login/login.rest";
import { WorklogsRest } from "../worklogs.rest";
import { ProjectsRowsModule } from "../../projects/project-rows/project-rows.module";
import { CustomersListModule } from "../../company/customers/customers-list/customers-list.module";
import { ProjectRowsComponent } from "../../projects/project-rows/project-rows.component";
import { CustomersListComponent } from "../../company/customers/customers-list/customers-list.component";
import { ProjectsRest } from "../../projects/projects.rest";
import { CustomersRest } from "../../company/customers/customers.rest";
import { IssuesRest } from "../../issues/issues.rest";
import { WorklogHeaderComponent } from "./worklog-header/worklog-header.component";

@NgModule({
    imports:[
        CommonModule,
        SharedModule,
        CustomersListModule,
        ProjectsRowsModule
        ],
    declarations:[WorklogDetailsComponent, WorklogHeaderComponent ],
    entryComponents: [ProjectRowsComponent, CustomersListComponent],
    providers: [WorklogDetailsComponent, WorklogHeaderComponent, WorklogsRest, LoginRest,  ProjectsRest, CustomersRest, IssuesRest ],
    exports: []
})
export class WorklogDetailsModule{}